/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import api from '../../../_metronic/helpers/api'
import {KTSVG} from '../../../_metronic/helpers'
import useUtils from './useUtils'
import {useDispatch} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import {Badge} from 'react-bootstrap'
import {showAlert} from '../../redux/reducers/alertSlice'
import Pagination from '../../modules/pagination/Pagination'
import formatDate from '../../../_metronic/helpers/formatDate'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'
import {DateRangePicker} from 'rsuite'
import {addDays, differenceInDays} from 'date-fns'
import TableSkeleton from '../../modules/skeleton/TableSkelton'
import Papa from 'papaparse'
import {unparse} from 'papaparse'
import saveAs from 'file-saver'
import CryptoJS from 'crypto-js'
import CSVModal from '../../modules/modal/CSVModal'

const UserList = ({className}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [selected, setSelected] = useState([])
  const [bulkType, setBulkType] = useState('')
  const {fetchUsers, fetchSubscriptions, fetchUser, addCSV, fetchAllUsers, submitReport} =
    useUtils()
  const previousSearchTerm = useRef('')
  const navigate = useNavigate()
  const [selectedSubscription, setSelectedSubscription] = useState(null)
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY || '')
  const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV || '')

  const [isOpen, setIsOpen] = useState(false)
  const [csvData, setcsvData] = useState(null)
  const [isUpload, setIsUpload] = useState(false)
  const today = new Date()
  const lastSevenDays = new Date(today)
  lastSevenDays.setDate(today.getDate() - 6)

  const [dateRange, setDateRange] = useState([null, null])
  const [subscriptionOptions, setSubscrriptionOptions] = useState()

  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [state, setState] = useState(null)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [uploadLoading, setUploadLoading] = useState(false)
  const dispatch = useDispatch()
  dispatch(setTitle('User'))

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPages, setTotalPages] = useState(1)

  const [isLoading, setLoading] = useState(false)
  const [selectedType, setSelectedType] = useState(null)
  const [selectedState, setSelectedState] = useState(null)
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [user, setUser] = useState()
  const fileInputRef = useRef(null)

  const getUser = async () => {
    try {
      if (searchTerm === previousSearchTerm.current) {
        setLoading(true)
      }
      const offset = (page - 1) * limit
      const result = await fetchUsers(
        searchTerm,
        selectedOrder,
        selectedType,
        selectedState,
        selectedSubscription,
        dateRange,
        limit,
        offset
      )
      setTotalPages(Math.ceil(result?.count / limit))
      setUser(result)
      previousSearchTerm.current = searchTerm
    } catch (error) {
      console.error('Error loading data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUser()
  }, [
    searchTerm,
    selectedType,
    limit,
    selectedOrder,
    selectedState,
    selectedSubscription,
    dateRange,
    page,
  ])

  const getSubscriptions = async () => {
    try {
      const subscriptions = await fetchSubscriptions()
      setSubscrriptionOptions(subscriptions)
    } catch (error) {
      console.error('Error loading data:', error)
    }
  }

  const getSingleUser = async (id) => {
    try {
      setLoading(true)
      const result = await fetchUser(id)

      navigate('/userlist/viewuser', {state: {values: result}})
    } catch (error) {
      console.error('Error loading data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getSubscriptions()
  }, [])

  const handleDownload = async () => {
    try {
      setDownloadLoading(true)
      const data = await fetchAllUsers(
        searchTerm,
        selectedOrder,
        selectedType,
        selectedState,
        selectedSubscription,
        dateRange
      )
      const csv = unparse(data, {header: true})
      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
      saveAs(blob, 'users.csv')
    } catch (error) {
      console.error('Error downloading users:', error)
    } finally {
      setDownloadLoading(false)
    }
  }

  const uploadFile = async (data) => {
    let successRecords = 0
    const failedRecords = []
    try {
      if (data.length <= 100) {
        const response = await addCSV(data)

        if (!response) {
          return
        }

        if (response.success) {
          successRecords += response.success
        }
        if (response.failed?.length > 0) {
          failedRecords.push(...response.failed) // Push failed records
        }
        if (response?.existingEmails?.length > 0) {
          response.existingEmails.forEach((item) => {
            failedRecords.push({message: 'Email already exists', detail: item})
          })
        }
        const successMessage = response?.success
          ? `${successRecords} users uploaded successfully`
          : ''
        const failedMessage = failedRecords.length
          ? `${failedRecords.length} users failed to upload`
          : ''
        const combinedMessage = [successMessage, failedMessage].filter(Boolean).join('. ')
        dispatch(showAlert({message: combinedMessage, variant: 'info', timeout: 5000}))
      } else {
        const chunkSize = 100
        const chunks = []
        for (let i = 0; i < data.length; i += chunkSize) {
          chunks.push(data.slice(i, i + chunkSize))
        }
        const uploadPromises = chunks.map((chunk) => addCSV(chunk))
        const response = await Promise.all(uploadPromises)
        response.forEach((response) => {
          if (response?.success) {
            successRecords += response.success
          }
          if (response.failed?.length > 0) {
            failedRecords.push(...response.failed) // Aggregate failed records
          }
          if (response?.existingEmails?.length > 0) {
            response.existingEmails.forEach((item) => {
              failedRecords.push({message: 'Email already exists', detail: item})
            })
          }
        })

        const successMessage = successRecords ? `${successRecords} users uploaded successfully` : ''
        const failedMessage = failedRecords.length
          ? `${failedRecords.length} users failed to upload`
          : ''
        const combinedMessage = [successMessage, failedMessage].filter(Boolean).join('. ')
        dispatch(showAlert({message: combinedMessage, variant: 'info', timeout: 5000}))
      }

      const finalSummary = {
        recordType: 'Users',
        totalRecords: data.length,
        successRecords: successRecords,
        failedRecords: failedRecords,
      }

      const res = await submitReport(finalSummary)
      if (res) {
        dispatch(
          showAlert({message: 'Report Submitted Successfully', variant: 'info', timeout: 5000})
        )
      } else {
        console.log('Error')
      }
    } catch (error) {
      console.error('Error uploading users:', error)
    } finally {
      setUploadLoading(false)
      getUser()
    }
  }

  const handleFileChange = (event) => {
    setUploadLoading(true)
    const file = event.target.files[0]
    if (file) {
      if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
        Papa.parse(file, {
          header: true,
          complete: (result) => {
            setIsOpen(true)
            setcsvData(result?.data)
            event.target.value = null
          },
          error: (error) => {
            console.error('Error parsing CSV:', error)
          },
        })
      } else {
        dispatch(showAlert({message: 'Please select a valid CSV file.', variant: 'danger'}))
      }
    }
  }

  const handleStateChange = (status) => {
    setSelectedState(status)
  }

  const handleOrderChange = (order) => {
    setSelectedOrder(order)
  }

  const handleTypeChange = (status) => {
    setSelectedType(status)
  }

  const handleDelete = (id, isActive) => {
    setSelectedId(id)
    setState(isActive)
    setModalVisible(true)
  }

  const handleBulkDelete = (bulk) => {
    setSelectedId(null)
    setBulkType(bulk)
    setState('')
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    try {
      if (selectedId) {
        const response = await api.patch(`/user/${selectedId}`, {isActive: state})
        if (response.data.status) {
          const result = await fetchUsers(
            searchTerm,
            null,
            selectedType,
            selectedState,
            selectedSubscription,
            dateRange,
            limit,
            (page - 1) * limit
          )

          setUser(result)

          if (state) {
            dispatch(showAlert({message: `Successfully Activated`, variant: 'success'}))
          } else {
            dispatch(showAlert({message: `Successfully Deativated`, variant: 'success'}))
          }
        }
      } else {
        const response = await api.post(`/user/bulk-activate`, {
          userIds: selected,
          isActive: bulkType == 'activate' ? true : false,
        })
        if (response.data.status === 'success') {
          const result = await fetchUsers(
            searchTerm,
            null,
            selectedType,
            selectedState,
            selectedSubscription,
            dateRange,
            limit,
            (page - 1) * limit
          )

          setUser(result)
          setSelected([])
          if (state) {
            dispatch(showAlert({message: `Successfully Activated`, variant: 'success'}))
          } else {
            dispatch(showAlert({message: `Successfully Deativated`, variant: 'success'}))
          }
        }
      }
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
      setState(null)
    }
  }

  const handleDateChange = (range) => {
    if (range && range[0] && range[1]) {
      let startTimestamp = new Date(range[0].getTime() - range[0].getTimezoneOffset() * 60000)
      let endTimestamp = new Date(range[1].getTime() - range[1].getTimezoneOffset() * 60000)
      const dayDifference = differenceInDays(endTimestamp, startTimestamp)

      if (dayDifference > 90) {
        endTimestamp = addDays(startTimestamp, 90)
      }
      // const formattedStartDate = moment(startTimestamp).format('YYYY-MM-DD')
      // const formattedEndDate = moment(endTimestamp).format('YYYY-MM-DD')
      setDateRange([startTimestamp, endTimestamp])
    } else {
      setDateRange([null, null])
    }
  }

  const predefinedBottomRanges = [
    {
      label: 'Today',
      value: [new Date(), new Date()],
    },
    {
      label: 'Last 7 days',
      value: [new Date(new Date().setDate(new Date().getDate() - 6)), new Date()],
    },
    {
      label: 'Last 30 days',
      value: [new Date(new Date().setDate(new Date().getDate() - 29)), new Date()],
    },
    {
      label: 'Last 90 days',
      value: [new Date(new Date().setDate(new Date().getDate() - 89)), new Date()],
    },
  ]

  useEffect(() => {
    if (csvData) {
      const transformedData = csvData?.map((obj, index) => ({
        id: obj?.id || undefined,
        name: obj?.name,
        email: obj?.email,
        password: CryptoJS.AES.encrypt(obj?.password, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }).toString(),
        blackForceMember: obj?.blackForceMember == 'TRUE' || obj?.blackForceMember == 'true',
        isPremiumUser: obj?.isPremiumUser == 'TRUE' || obj?.isPremiumUser == 'true',
        subscriptionId: obj?.subscriptionId || null,
      }))

      // const dataToUpload = transformedData.slice(0, -1)
      const dataToUpload = transformedData.filter(
        (record) => record.name?.trim() && record.email?.trim() && record.password?.trim()
      )

      uploadFile(dataToUpload)
      setcsvData(null)
    }
  }, [isUpload])

  if (isLoading) return <TableSkeleton />
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start'>
          {/* <span className='card-label fw-bold fs-3 mb-1'>Units List</span> */}
          <span className=' mt-1 text-muted fs-7 '>{user?.count} Items</span>
        </h3>
        <div className='d-flex align-items-center justify-content-between w-100 mt-5 flex-wrap'>
          {/* begin::Search */}
          <div className='d-flex align-items-center flex-wrap gap-3'>
            <div className='d-flex align-items-center'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-3 position-absolute ms-6'
              />
              <input
                type='text'
                data-kt-user-table-filter='search'
                className='form-control fs-7 form-control-solid w-250px h-40px ps-14'
                placeholder='Search Users'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {/* end::Search */}
            </div>

            <div>
              <select
                value={selectedType || ''}
                aria-placeholder='Type'
                className='form-select form-select-solid fs-7 h-40px w-150px text-muted select2-hidden-accessible'
                onChange={(e) => handleTypeChange(e.target.value)}
              >
                <option value={null}>Type</option>
                <option value={true}>Subscribed</option>
                <option value={false}>UnSubscribed</option>
              </select>
            </div>

            <div>
              <select
                value={selectedOrder || ''}
                aria-placeholder='Type'
                className='form-select form-select-solid fs-7 h-40px w-150px text-muted select2-hidden-accessible'
                onChange={(e) =>
                  handleOrderChange(e.target.value === 'No of referrals' ? null : e.target.value)
                }
              >
                <option value={null}>No of referrals</option>
                <option value='ASC'>Higher to low</option>
                <option value='DESC'>Lower to high</option>
              </select>
            </div>
            <div>
              <select
                value={selectedState || ''}
                className='form-select form-select-solid fs-7 h-40px w-150px text-muted select2-hidden-accessible'
                onChange={(e) => handleStateChange(e.target.value)}
              >
                <option value={null}>State</option>

                <option value={true} data-select2-id='select2-data-12-vz6w'>
                  Active
                </option>

                <option value={false} data-select2-id='select2-data-12-vz6w'>
                  In Active
                </option>
              </select>
            </div>

            <div>
              <select
                value={selectedSubscription || ''}
                className='form-select form-select-solid text-muted  fs-7 h-40px w-150px  select2-hidden-accessible'
                onChange={(e) => setSelectedSubscription(e.target.value)}
              >
                <option value={null}>Subscription</option>

                {subscriptionOptions?.map((c, index) => (
                  <option key={index} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>

            <DateRangePicker
              value={dateRange}
              defaultValue={null}
              ranges={predefinedBottomRanges}
              placeholder='Select date range'
              format='dd MMM, yy'
              cleanable
              style={{width: 200}}
              onChange={handleDateChange}
              placement='auto'
            />
          </div>
          <div className='card-toolbar'>
            <div>
              <span
                onClick={() => fileInputRef.current.click()}
                className='btn btn-sm btn-light-primary me-2'
              >
                {uploadLoading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  <>
                    <KTSVG path='/media/icons/duotune/files/fil010.svg' className='svg-icon-2' />
                    Upload CSV
                  </>
                )}
              </span>
              <input
                type='file'
                ref={fileInputRef}
                style={{display: 'none'}}
                accept='.csv'
                onChange={handleFileChange}
              />
            </div>

            <span onClick={() => handleDownload()} className='btn btn-sm btn-light-primary me-2'>
              {downloadLoading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : (
                <>
                  <KTSVG path='/media/icons/duotune/files/fil003.svg' className='svg-icon-2 me-1' />
                  Download CSV
                </>
              )}
            </span>
            <div className=''>
              {selected.length > 0 && (
                <span className='d-flex gap-2'>
                  <span
                    className='btn btn-sm btn-primary'
                    onClick={() => handleBulkDelete('activate')}
                  >
                    Activate Selected
                  </span>
                  <span
                    className='btn btn-sm btn-danger'
                    onClick={() => handleBulkDelete('deactivate')}
                  >
                    Deactivate Selected
                  </span>
                </span>
              )}
            </div>
          </div>
        </div>
        {/* <div className=''>
          {selected.length > 0 && (
            <span className='d-flex gap-2 mt-1'>
              <a className='btn btn-sm btn-primary' onClick={() => handleBulkDelete('activate')}>
                Activate Selected
              </a>
              <a className='btn btn-sm btn-danger' onClick={() => handleBulkDelete('deactivate')}>
                Deactivate Selected
              </a>
            </span>
          )}
            </div> */}
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      {user?.count === 0 && (
        <div className='mt-20 mb-20 w-sm-100 w-md-75 mx-auto p-5 py-20'>
          <div className='card-body text-center'>
            <span className='svg-icon svg-icon-2hx svg-icon-info mb-5'>
              <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-2x' />
            </span>
            <h4 className='mb-1'>No Records Found</h4>
            <span>Add more Users or change the filters</span>
          </div>
        </div>
      )}

      {user?.count > 0 && (
        <div className='card-body py-10'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bold text-muted'>
                  <th>
                    {' '}
                    <div className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        className='form-check-input widget-9-check'
                        type='checkbox'
                        checked={user.records.every((item) => selected.includes(item.id))}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelected(user.records.map((item) => item.id))
                          } else {
                            setSelected([])
                          }
                        }}
                      />
                    </div>
                  </th>
                  <th className='w-100px'>ID</th>
                  <th className='w-100px text-nowrap'>FULL NAME</th>
                  <th className='w-50px '>EMAIL</th>
                  <th className='text-center text-nowrap'>NO OF REFERALS</th>
                  <th className='w-200px text-nowrap'>LAST LOGIN AT</th>
                  <th className=''>TYPE</th>
                  <th className=' text-nowrap'>Black Force Member</th>
                  <th className='w-50px '>STATE</th>
                  <th className='min-w-100px text-end'>ACTIONS</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {user?.records &&
                  user?.records?.map((value, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div className='form-check form-check-sm form-check-custom form-check-solid'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              value={value?.id}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelected((prevSelected) => [...prevSelected, value.id])
                                } else {
                                  setSelected((prevSelected) =>
                                    prevSelected.filter((id) => id !== value.id)
                                  )
                                }
                              }}
                              checked={selected.includes(value.id)}
                            />
                          </div>
                        </td>
                        <td className='text-nowrap'>
                          <span className='text-dark fw-bold  fs-6'>{value.id}</span>
                        </td>
                        <td>
                          <span className='text-dark text-nowrap fw-bold  fs-6'>{value?.name}</span>
                        </td>
                        <td>
                          <a href='#' className='text-dark fw-bold text-nowrap d-block mb-1 fs-6'>
                            {value?.email}
                          </a>
                        </td>
                        <td>
                          <a
                            href='#'
                            className='text-dark d-flex justify-content-center fw-bold  d-block mb-1 fs-6'
                          >
                            {value?.totalReferrals || 0}
                          </a>
                        </td>
                        <td>
                          <a href='#' className='text-dark fw-bold  d-block mb-1 fs-6'>
                            {!value.lastLogin
                              ? 'Yet to login'
                              : `${
                                  !isNaN(Number(value.lastLogin))
                                    ? formatDate(value.lastLogin)
                                    : 'Invalid Start Date'
                                }`}
                          </a>
                        </td>
                        <td>
                          <a href='#' className='text-dark fw-bold  r  d-block mb-1 fs-6'>
                            {!value?.isSubscribed ? 'Not Subscribed' : value?.subscription?.name}
                          </a>
                        </td>
                        <td>
                          <a href='#' className='text-dark fw-bold  r  d-block mb-1 fs-6'>
                            {value?.blackForceMember ? 'Yes' : 'No'}
                          </a>
                        </td>

                        <td>
                          <a href='#' className='text-dark fw-bold   d-block mb-1 fs-6'>
                            <Badge
                              bg={value?.isActive === true ? 'success' : 'warning'}
                              text={value?.isActive !== true ? 'dark' : ''}
                            >
                              {value?.isActive === true ? 'Active' : 'Not Active'}
                            </Badge>
                          </a>
                        </td>

                        <td className='d-flex justify-content-end gap-2'>
                          <a
                            onClick={() => getSingleUser(value?.id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            style={{visibility: value?.id ? 'visible' : 'hidden'}}
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen019.svg'
                              className='svg-icon-3 svg-icon-primary'
                            />
                          </a>
                          <a
                            href='#'
                            style={{width: '140px'}}
                            onClick={() => handleDelete(value.id, !value.isActive)}
                            className='btn btn-sm btn-light-primary text-nowrap'
                          >
                            {value.isActive ? 'Deactivate User' : 'Activate User'}
                          </a>
                        </td>
                      </tr>
                    )
                  })}
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
        </div>
      )}
      <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
        <div className='d-flex align-items-center gap-3'>
          <span className='fs-6 text-muted'>Show</span>
          <div>
            <select
              defaultValue={limit}
              className='form-select form-select-solid text-muted select2-hidden-accessible'
              onChange={(e) => {
                setPage(1)
                setLimit(e.target.value)
              }}
            >
              <option>10</option>
              <option>20</option>
              <option>50</option>
              <option>100</option>
            </select>
          </div>
        </div>
        <DeleteConfirmation
          isVisible={modalVisible}
          message={
            selectedId
              ? state
                ? 'Are you sure you want to activate?'
                : 'Are you sure you want to deactivate?'
              : bulkType === 'activate'
              ? 'Are you sure you want to activate selected users?'
              : 'Are you sure you want to deactivate selected users'
          }
          onConfirm={confirmDelete}
          onCancel={() => setModalVisible(false)}
        />
        {isOpen && (
          <CSVModal
            show={isOpen}
            upload={() => setIsUpload((prev) => !prev)}
            optionalFields={['subscriptionId']}
            handleClose={() => {
              setIsOpen(false)
              setUploadLoading(false)
            }}
            handleCancel={() => {
              setIsOpen(false)
              setUploadLoading(false)
            }}
            csvData={csvData}
          />
        )}
        <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
      </div>
      {/* begin::Body */}
    </div>
  )
}

export default UserList
